import { styled } from '@mui/material/styles';

export const StyledContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '36px',
  marginTop: '25px',
  fontFamily: theme?.fonts?.robotoRegular,
  fontSize: theme?.fontSize?.small,
  textAlign: 'left',

  span: {
    textAlign: 'left',
  },
}));
